import React from 'react'
import { SVGIconProps } from '../types'
const SvgViewColumn = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M10 18h5V5h-5zm-6 0h5V5H4zM16 5v13h5V5z" />
  </svg>
)
export default SvgViewColumn
